import {h, Fragment} from "preact"
import { useAppStateSelector, pick, useProductFilters } from "@nosto/preact"
import { useEffect } from "preact/hooks"

import { NORESULTS_RECID } from "../config"

export default function NoResults() {
    const { query, response, pageType } = useAppStateSelector(state =>
        pick(state, "query", "response","pageType")
    )
    const { filters, removeAll } = useProductFilters();

    useEffect(() => {
        
        if(!window.nostojs) return;
        window.nostojs(api => {
            api
            .createRecommendationRequest({ includeTagging: true })
            .setElements(NORESULTS_RECID)
            .load({ skipPageViews: true, skipEvents: true })
        })
    }, [])

    return (
        <>
            <div class="px-pagemargin py-lg pb-md md:pb-lg flex flex-col gap-2xs">
                <div class="utility mb-xs text-sm">
                    {pageType === "search" ? "Search results" : ""}
                </div>
                {pageType === "search" ? (
                    <h1 class="h2">
                    Sorry, we couldn't find a match for "{query.query}".
                    </h1>
                ) :(
                    <h3 class="h2">
                        Sorry, we couldn't find any products.
                    </h3>
                )}
                <p class="text-base">
                    {pageType === "search" 
                        ? "Try changing your search to something less specific or check your spelling."
                        :   <>
                                No products found. 
                                {filters?.length > 0 && (
                                    <>
                                    Use fewer filters or <button type="button" class="text-base" onClick={removeAll} aria-label="Clear all filters.">clear all.</button>
                                    </>
                                )}
                            </>
                    }
                </p>
            </div>
            <div class="ns-noresults-rec px-pagemargin mt-4 lg:mt-8">
                <div class="nosto_element" id={NORESULTS_RECID} />
            </div>
        </>
    )
}
